import type {
	PortalTransactionListResponseDto,
	PortalTransactionQueryDto,
} from '@supply-mover-2-0/shared';
import { buildQueryString, portalFetch } from '../lib/apiClient';

/**
 * Fetch the paginated transaction list across the user's assigned clients.
 */
export async function getTransactions(
	token: string,
	params: PortalTransactionQueryDto,
): Promise<PortalTransactionListResponseDto> {
	const qs = buildQueryString({
		page: params.page,
		limit: params.limit,
		clientId: params.clientId,
		dateFrom: params.dateFrom,
		dateTo: params.dateTo,
	});
	return portalFetch<PortalTransactionListResponseDto>(
		`/transactions${qs}`,
		token,
	);
}
